export default __webpack_public_path__ + "static/Virtual_reality-1b040e4387bec437acb2cc8bad018b43.svg";